import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import VersionHistory from './VersionHistory';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function VersionHistoryPanel({
  errorMessage,
  numVersions,
  offeringId,
  panelBodyHeader,
  panelFooter,
  panelHeader,
  panelSubheader,
  renderVersionActions,
  versionHistoryQuery,
  width
}) {
  return /*#__PURE__*/_jsxs(ModalPanel, {
    width: width,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: panelHeader
    }), panelSubheader, /*#__PURE__*/_jsxs(DialogBody, {
      children: [panelBodyHeader, /*#__PURE__*/_jsx(VersionHistory, {
        errorMessage: errorMessage,
        numVersions: numVersions,
        offeringId: offeringId,
        renderVersionActions: renderVersionActions,
        versionHistoryQuery: versionHistoryQuery
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: panelFooter
    })]
  });
}